import { createFileRoute } from "@tanstack/react-router";
import CityPage from "@/pages/service-areas/CityPage";
import { seo, breadcrumbSchema } from "@/lib/seo";
import { buildFaqPageSchema, buildRoofingContractorSchema } from "@/lib/schema";
import { serviceAreaCities } from "@/data/serviceAreas";

export const Route = createFileRoute("/_site/service-areas/$slug")({
  head: ({ params }) => {
    const city = serviceAreaCities.find((c) => c.slug === params.slug);
    if (!city) {
      return seo({
        title: "Service Area Not Found",
        description: "This service area page could not be found.",
        path: `/service-areas/${params.slug}`,
        noindex: true,
      });
    }

    return seo({
      title: `${city.name}, MN Roofing & Siding Contractor`,
      description: `Roofing, LP SmartSide siding, and gutter services in ${city.name}, MN. Locally trusted Cedar Creek crew—call (612) 298-9865 for a free estimate.`,
      path: `/service-areas/${city.slug}`,
      image: city.heroImage,
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Service Areas", path: "/service-areas" },
          { name: city.name, path: `/service-areas/${city.slug}` },
        ]),
        buildRoofingContractorSchema(),
        ...(city.faqs?.length ? [buildFaqPageSchema(city.faqs)] : []),
      ],
    });
  },
  component: CityPage,
});
